export default "__VITE_ASSET__VfUhqvwG__"